
export default (setPools: Function) => (poolId: string, value: boolean) => {

  return setPools((ps: any) => ps.map((item: any) => ({
    ...item,
    pinned: item._id === poolId ? value : item.pinned,
  })));
}